import { useQuery } from '@tanstack/react-query';
import { ZONES_QUERY_KEY } from 'constants/queryKeys';
import { QUERY_STALE_TIME_MS } from 'constants/appConstants';
import useFetchOrganisations from 'hooks/useFetchOrganisations';
import useFetchUserProfile from 'hooks/useFetchUserProfile';
import ZoneService from 'services/ZoneService';

/**
 * Fetches all zone documents for an organisation.
 * Zones are the canonical data source for the map — each zone carries
 * geoData, zoneType, and links back to its parent paddock.
 * @param orgId - The organisation ID to fetch zones for
 */
export const useFetchZonesByOrgId = (orgId: string | null) => {
  const { data: userData, isError: isUserDataError } = useFetchUserProfile();
  const { data: organisationsData, isError: isOrganisationsError } =
    useFetchOrganisations();

  return useQuery({
    queryKey: [ZONES_QUERY_KEY, orgId],
    queryFn: () => {
      if (!orgId) return [];
      return ZoneService.GetByOrgActive(orgId);
    },
    enabled:
      !!orgId &&
      !!userData &&
      !isUserDataError &&
      !isOrganisationsError &&
      !!organisationsData,
    staleTime: QUERY_STALE_TIME_MS,
  });
};

export default useFetchZonesByOrgId;
